<template>


    <div>

        <div>

            <!-- 从来未开通 -->
            <div class="main " v-if="!isOldVip()">
                <div class="centered relative" style="width: 339px;" @click="viewVip()">
<!--                    <router-link to="/vip">-->
                        <img class="block w100p" src="me/vip/bg_nu_open.png" title="VIP会员">
<!--                        <img class="openButton" src="me/vip/btn_nu_open.svg" title="立即开通">-->
<!--                    </router-link>-->
                </div>
            </div>

            <div v-else-if="hasVip">

                <!-- 已开通 商学院VIP  但不需要提示 -->
<!--                <div class="main " v-if="vipInfo['kindergarten_vip'].status">-->
<!--                    <div class="centered relative" style="width: 339px;" data-click="viewVip('kindergarten_vip')">-->
<!--                        <img class="block w100p" src="me/vip/bg_kindergarten_vip_bg.png">-->
<!--                        <div class="dueTime clearfix">-->
<!--                            <div class="timeInfo ">-->
<!--                                <span v-if="vipInfo['kindergarten_vip'].expiring>30">-->
<!--                                    已开通｜有效期至：{{vipInfo['kindergarten_vip'].dueTime.substr(0,10)}}-->
<!--                                </span>-->
<!--                                <span v-else>-->
<!--                                    30天内即将过期，会员权益将失效-->
<!--                                </span>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

                <!-- 已开通 CourseVod  但不需要提示 -->
<!--                <div class="main " v-else-if="vipInfo['course_vod'].status">-->
<!--                    <div class="centered relative" style="width: 339px;" data-click="viewVip('course_vod')">-->
<!--                        <img class="block w100p" src="me/vip/bg_course_vip_due_to.png">-->
<!--                        <div class="dueTime clearfix">-->
<!--                            <div class="timeInfo ">-->
<!--                                <span v-if="vipInfo['course_vod'].expiring>30">-->
<!--                                    已开通｜有效期至：{{vipInfo['course_vod'].dueTime.substr(0,10)}}-->
<!--                                </span>-->
<!--                                <span v-else>-->
<!--                                    30天内即将过期，会员权益将失效-->
<!--                                </span>-->
<!--                            </div>-->
<!--                        </div>-->
<!--&lt;!&ndash;                        <img class="openButton" src="me/vip/btn_course_un_open.svg"&ndash;&gt;-->
<!--&lt;!&ndash;                             @click.stop.prevent="$emit('renewVip', {type : 'course_vod'})">&ndash;&gt;-->
<!--                    </div>-->
<!--                </div>-->

                <!-- 已开通 DatumVIP  但不需要提示 -->
                <div class="main " v-if="vipInfo['datum'].status">
                    <div class="centered relative" style="width: 339px;" @click="viewVip('datum')">
                        <img class="block w100p" src="me/vip/bg_datum_vip_due_to.png">
                        <div class="dueTime clearfix">
                            <div class="timeInfo ">
                                <span v-if="vipInfo['datum'].expiring>30">
                                    已开通｜有效期至：{{vipInfo['datum'].dueTime.substr(0,10)}}
                                </span>
                                <span v-else>
                                    30天内即将过期，会员权益将失效
                                </span>
                            </div>
                        </div>
<!--                        <img class="openButton" src="me/vip/btn_datum_re.svg"-->
<!--                             @click.stop.prevent="$emit('renewVip', {type : 'datum'})">-->
                    </div>
                </div>

                <!-- 已开通 AtlasVIP  但不需要提示 -->
<!--                <div class="main" v-else-if="vipInfo['atlas_vip'].status">-->
<!--                    <div class="centered relative" style="width: 339px;" data-click="viewVip('atlas_vip')">-->
<!--                        <img class="block" src="me/vip/bg_atlas_open.png" width="100%" height="auto">-->
<!--                        <div class="dueTime clearfix">-->
<!--                            <div class="timeInfo">-->
<!--                                <span v-if="vipInfo['atlas_vip'].expiring>30">-->
<!--                                    已开通｜有效期至：{{vipInfo['atlas_vip'].dueTime.substr(0,10)}}-->
<!--                                </span>-->
<!--                                <span v-else>-->
<!--                                    30天内即将过期，会员权益将失效-->
<!--                                </span>-->
<!--                            </div>-->
<!--                        </div>-->
<!--&lt;!&ndash;                        <img class="openButton" src="me/vip/btn_datum_re.svg"&ndash;&gt;-->
<!--&lt;!&ndash;                             @click.stop.prevent="$emit('renewVip', {type : 'atlas_vip'})">&ndash;&gt;-->
<!--                    </div>-->
<!--                </div>-->

            </div>

            <!-- 已过期 -->
            <div class="main " v-else data-visible="!isHasVip()" >
                <div class="centered relative" style="width: 339px;" @click="viewVip()">
                    <img class="block" src="me/vip/bg_vip_overdue.png" width="100%" height="auto">
<!--                    <img class="openButton" src="me/vip/btn_vip_overdue.svg"-->
<!--                         @click.stop.prevent="viewVip()">-->
                </div>
            </div>

        </div>

    </div>

</template>

<script>

import appHelper from '@util/appHelper';

    export default {
        name: "meVipInfo",
        data() {
            return {
                hasVip: false,
                expiring: false,
                vipType: 0,
                oldVip: false
            }
        },
        props: {
            vipInfo: {},
        },
        methods: {
            /**
             *
             * @param   {String}    vipType     super|datum|course_vod
             */
            viewVip(vipType) {
                vipType ? appHelper.redirect('/vip/' + vipType)
                    : appHelper.redirect('/vip');

            },
            updateStatus() {
                let me = this;
                if (!me.vipInfo)
                {
                    return;
                }

                //当前有没有VIP
                me.hasVip = me.vipInfo['super'].status || me.vipInfo['course_vod'].status ||
                    me.vipInfo['datum'].status || me.vipInfo['atlas_vip'].status ||
                    me.vipInfo['business_vip'].status
                //有过VIP
                const nullTime = '0000-00-00 00:00';
                me.oldVip = me.vipInfo['super'].dueTime != nullTime || me.vipInfo['course_vod'].dueTime != nullTime ||
                    me.vipInfo['datum'].dueTime != nullTime || me.vipInfo['atlas_vip'].dueTime != nullTime ||
                    me.vipInfo['business_vip'].dueTime != nullTime
            },
            isOldVip() {
                this.updateStatus();
                return this.oldVip;
            },
            isHasVip() {
                this.updateStatus();
                return this.hasVip;
            },


        },
        mounted() {
            this.updateStatus();
        }
    };
</script>

<style lang="scss" scoped>
    .main {
        padding: 16px 18px 0;
    }

    .timeInfo {
        height: 18px;
        background: rgba(8, 8, 8, 0.2);
        border-radius: 10px;
        line-height: 18px;
        /*padding-top: 66px;*/
        span {
            font-size: 10px;
            font-weight: 500;
            line-height: 17px;
            color: #FFFFFF;
            margin-left: 8px;
            margin-right: 8px;
        }

    }

    .dueTime {
        position: absolute;
        z-index: 1;
        bottom: 12px;
        left: 12px;
    }

    .openButton {
        position: absolute;
        z-index: 1;
        bottom: 12px;
        right: 12px;
    }
</style>
